export const ENDPOINTS = {
  getStatesByCountry: (country) => `/api/o/state/grid?country=${country}&rows=-1`,
};
